import Style from "../scss/text.module.scss";

export function TitleH1Component(props) {
    return (
        <h1 className={`${Style.h1} ${props.styleGroup}`}>{props.children}</h1>
    );
}